import { render } from "./AddCompletion.vue?vue&type=template&id=1c5606c4&scoped=true"
import script from "./AddCompletion.vue?vue&type=script&lang=js"
export * from "./AddCompletion.vue?vue&type=script&lang=js"

import "./AddCompletion.vue?vue&type=style&index=0&id=1c5606c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5606c4"]])

export default __exports__